import {
    Component, EventEmitter,
    Input, Output,
} from '@angular/core';
import {ERateType} from "../../../../../../service/resources/booking/interfaces/get-bookings.enum";
import {SectorInBookingType} from "@afidium/ts-facade/model/sectorInBookingType";

export interface ISelectedRate {
    selected: boolean;
    rateId: string;
}

@Component({
    selector: 'rate-sectors',
    template: `
        <div class="sectors-container">
            <fa-icon class="add-margin" [icon]="rateType | computeRate | computeRateIcon"></fa-icon>
            <ng-container [ngSwitch]="rateType | computeRate">
                <span *ngSwitchCase="eRateType.Fee">{{rateTitle}}</span>
                <ng-container *ngSwitchDefault>
                    <a class="add-margin link" (click)="onClick()"> {{rateTitle}}</a>
                    <div class="sectors-list">
                        <sectors-air-simple-list
                                class="main-informations"
                                [sectors]="sectors"></sectors-air-simple-list>
                    </div>
                </ng-container>
            </ng-container>
        </div>
        <sectors-air-summary-with-rupture *ngIf="sectorsDetailsShown"
                                          [sectors]="sectors"></sectors-air-summary-with-rupture>
    `,
    styles: [`
        .sectors-container {
            display: flex;
            align-items: baseline;
            margin-bottom: .75rem;
            font-weight: bold;
        }

        .add-margin {
            margin-right: .75rem;
        }

        .sectors-list {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
        }

        .main-informations {
            min-width: 80%;
            margin-right: .75rem;
        }
        
        .link {
            color: #337ab7;
        }

    `]
})
export class RateSectorsComponent {

    @Input()
    public sectors: SectorInBookingType[];

    @Input()
    public rateType: string;

    @Input()
    public rateId: string;

    @Input()
    public rateTitle: string;

    @Output()
    public readonly onRateSelect: EventEmitter<string> = new EventEmitter();

    public sectorsDetailsShown: boolean = false;
    public eRateType: typeof ERateType = ERateType;

    public onClick(): void {
        this.onRateSelect.emit(this.rateId);
    }
}
